module.exports = __webpack_public_path__ + "img/lambda.5fb1e3f7.svg";